import React, { Fragment } from "react";
import { Drawer, Spin } from "antd";
import DeleteIcon from "../../../images/vtrash.svg";
import EditIcon from "../../../images/vedit.svg";
import CloseIcon from "../../../images/vclose.svg";
import styles from "./styles.module.scss";
import moment from "moment";
import { API_URL } from "../../../config/environment";
import PersonAvatar from "../../../images/person-avatar.svg";
import _ from "lodash";
import UserAvatar from "../../../images/user-avatar.svg";
import { FormattedMessage } from "react-intl";

class ViewDrawer extends React.PureComponent {
  componentWillReceiveProps = (newProps) => {
    if (newProps.personToViewId !== this.props.personToViewId) {
      const { fetchPerson, personToViewId, userId, intl, siteLanguage } =
        newProps;
      fetchPerson(personToViewId, userId, intl, siteLanguage);
    }
  };
  imgError = (ev) => {
    ev.onerror = "";
    ev.target.src = `${UserAvatar}`;
    return true;
  };
  static defaultProps = {
    visible: false,
    maskClosable: true,
    destroyOnClose: true,
    width: "25%",
    drawerTitle: "View person",
    okText: "Add",
    cancelButtonProps: {
      type: "link",
      "data-dfs-people-id": "person-add-form-drawer-cancel-link",
    },
    okButtonProps: {
      loading: false,
      "data-dfs-people-id": "person-add-form-drawer-add-button",
    },
    centered: true,
    countries: [],
    myGroups: [],
    customDataKeys: [],
    data: {},
    bodyStyle: {
      backgroundColor: "#f9f9f9",
      paddingBottom: 53,
      paddingLeft: "2rem",
      minHeight: "100%",
    },
    onCancel() {},
    onOk() {},
  };

  render() {
    const {
      visible,
      maskClosable,
      destroyOnClose,
      width,
      onCancel,
      data,
      person,
      bodyStyle,
      personToViewId,
      handleEdit,
      handleDelete,
      fetchingPerson,
      editable,
    } = this.props;

    return (
      <Drawer
        destroyOnClose={destroyOnClose}
        width={width}
        maskClosable={maskClosable}
        visible={visible}
        onClose={onCancel}
        bodyStyle={bodyStyle}
        closable={false}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          <Spin spinning={fetchingPerson}></Spin>
          <div />
          <div>
            {editable && (
              <Fragment>
                <img
                  data-dfs-people="view-person-drawer-edit-person"
                  onClick={(e) => handleEdit(e, { key: personToViewId })}
                  className={styles.viewIcons}
                  src={EditIcon}
                  alt="Edit"
                />
                <img
                  data-dfs-people="view-person-drawer-delete-person"
                  onClick={(e) => handleDelete(e, { key: personToViewId })}
                  className={styles.viewIcons}
                  src={DeleteIcon}
                  alt="Delete"
                />
              </Fragment>
            )}

            <img
              data-dfs-people="view-person-drawer-close"
              onClick={onCancel}
              className={styles.viewIcons}
              src={CloseIcon}
              alt="Close"
            />
          </div>
        </div>
        <div>
          <h2 style={{ fontWeight: 300 }}>
            {data["Photo"] ? (
              <img
                className="avatar-preview"
                src={data["Photo"]}
                alt="profile"
                onError={this.imgError}
              />
            ) : (
              <img
                style={{ width: "3rem" }}
                src={PersonAvatar}
                alt="Person avatar"
              />
            )}{" "}
            {data["First Name"] || data["First Name "]}{" "}
            {data["Last Name"] || data["Last Name "]}
          </h2>
        </div>

        <div style={{ marginLeft: "3.5rem" }}>
          {data["Phone Number"] && (
            <div>
              <small className={styles.smHeader}>
                <FormattedMessage
                  id="PhoneNumber"
                  defaultMessage="Phone Number"
                />
              </small>
              <p className={styles.smBody}>{data["Phone Number"] || "-"}</p>
            </div>
          )}
          {data["Email"] && (
            <div>
              <small className={styles.smHeader}>
                <FormattedMessage id="Email" defaultMessage="Email" />
              </small>
              <p className={styles.smBody}>{data["Email"] || "-"}</p>
            </div>
          )}
          {data["Occupation"] && (
            <div>
              <small className={styles.smHeader}>
                <FormattedMessage id="Occupation" defaultMessage="Occupation" />
              </small>
              <p className={styles.smBody}>{data["Occupation"] || "-"}</p>
            </div>
          )}
          {!_.isEmpty(data["GPS Location"]) && (
            <div>
              <small className={styles.smHeader}>
                <FormattedMessage
                  id="GPSLocation"
                  defaultMessage="GPS Location"
                />
              </small>
              <p className={styles.smBody}>
                {`${
                  data["GPS Location"] && data["GPS Location"].longitude
                    ? data["GPS Location"].longitude
                    : "-"
                },${
                  data["GPS Location"] && data["GPS Location"].latitude
                    ? data["GPS Location"].latitude
                    : "-"
                }`}
              </p>
            </div>
          )}
          {data["Country"] && (
            <div>
              <small className={styles.smHeader}>
                <FormattedMessage id="Country" defaultMessage="Country" />
              </small>
              <p className={styles.smBody}>{data["Country"] || "-"}</p>
            </div>
          )}
          {data["City"] && (
            <div>
              <small className={styles.smHeader}>
                <FormattedMessage id="City" defaultMessage="City" />
              </small>
              <p className={styles.smBody}>{data["City"] || "-"}</p>
            </div>
          )}
          {data["Address 1"] && (
            <div>
              <small className={styles.smHeader}>
                <FormattedMessage id="Address" defaultMessage="Address" /> 1
              </small>
              <p className={styles.smBody}>{data["Address 1"] || "-"}</p>
            </div>
          )}
          {data["Address 2"] && (
            <div>
              <small className={styles.smHeader}>
                <FormattedMessage id="Address" defaultMessage="Address" /> 2
              </small>
              <p className={styles.smBody}>{data["Address 2"] || "-"}</p>
            </div>
          )}
          {data["Id Number"] && (
            <div>
              <small className={styles.smHeader}>
                <FormattedMessage id="IDNumber" defaultMessage="ID Number" />
              </small>
              <p className={styles.smBody}>{data["Id Number"] || "-"}</p>
            </div>
          )}
          {data["Title"] && (
            <div>
              <small className={styles.smHeader}>
                <FormattedMessage id="Title" defaultMessage="Title" />
              </small>
              <p className={styles.smBody}>{data["Title"] || "-"}</p>
            </div>
          )}
          {data["Gender"] && (
            <div>
              <small className={styles.smHeader}>
                <FormattedMessage id="Gender" defaultMessage="Gender" />
              </small>
              <p className={styles.smBody}>{data["Gender"] || "-"}</p>
            </div>
          )}
          {data["Date of Birth"] && (
            <div>
              <small className={styles.smHeader}>
                <FormattedMessage
                  id="DateOfBirth"
                  defaultMessage="Date Of Birth"
                />
              </small>
              <p className={styles.smBody}>{data["Date of Birth"] || "-"}</p>
            </div>
          )}

          <div>
            <small className={styles.smHeader}>
              <FormattedMessage id="DateAdded" defaultMessage="DateAdded" />
            </small>
            <p className={styles.smBody}>
              {moment.utc(person.posted_ts).format("DD-MM-YYYY")}
            </p>
          </div>
        </div>
      </Drawer>
    );
  }
}
export const ViewPersonDrawer = ViewDrawer;
